export default "__VITE_ASSET__57330c0c__"